module.exports = __webpack_public_path__ + "img/pressure.2722f861.svg";